import { Injectable } from "@angular/core";
import { DashboardItem } from "./../models/dashboard-item"
import { WidgetConfiguration } from "../../widget-configs/models/widget-configuration";
@Injectable()
export class DashboardItemMapper{

  mapWidgetConfigToDashboardItem(widgetConfig: WidgetConfiguration, dashboardName: string): DashboardItem {
    var newItem = new DashboardItem();
    newItem.title = widgetConfig.title;
    newItem.widgetName = widgetConfig.widgetTypeId;
    newItem.dashboardName = dashboardName;
    newItem.rows = widgetConfig.defaultRows;
    newItem.cols = widgetConfig.defaultColumns;
    newItem.widgetConfigId = widgetConfig.id;
    newItem.resizeEnabled = widgetConfig.resizeEnabled;
    return newItem;
  }

}
